module.exports = __webpack_public_path__ + "img/icon-home-ev-03.b2340d97.jpg";